<section class="tg-page-hero">
  <div class="tg-container">
    <h1 class="tg-page-hero__title">Mi Suscripción</h1>
    <ul class="tg-page-hero__breadcrumb">
      <li><a routerLink="/">Inicio</a></li>
      <li>›</li>
      <li>Suscripción</li>
    </ul>
  </div>
</section>

<div style="max-width:700px;margin:40px auto;padding:0 20px 64px;">

  <div *ngIf="cargando" style="text-align:center;padding:48px;color:#9ca3af;font-size:14px;">
    Cargando información de suscripción…
  </div>
  <div *ngIf="error" style="background:#fef2f2;border:1px solid #fecaca;border-radius:8px;padding:12px 16px;margin-bottom:20px;font-size:13px;color:#dc2626;">
    {{ error }}
  </div>

  <div *ngIf="suscripcion && !cargando">

    <!-- ── Status Card ───────────────────────────────────────────────────── -->
    <div style="background:#fff;border:1px solid #e5e7eb;border-radius:16px;padding:28px;margin-bottom:20px;">

      <div style="display:flex;align-items:flex-start;justify-content:space-between;flex-wrap:wrap;gap:16px;">

        <div style="flex:1;min-width:200px;">
          <span style="font-size:12px;color:#9ca3af;text-transform:uppercase;letter-spacing:.5px;font-weight:600;">Plan actual</span>

          <!-- PREMIUM -->
          <h3 *ngIf="suscripcion.status === 'PREMIUM'"
              style="margin:4px 0;font-size:clamp(18px, 3vw, 22px);color:#059669;">
            🌟 Premium
          </h3>

          <!-- CANCELANDO — Premium activo pero no se renovará -->
          <h3 *ngIf="suscripcion.status === 'CANCELANDO'"
              style="margin:4px 0;font-size:clamp(18px, 3vw, 22px);color:#d97706;">
            🌟 Premium <span style="font-size:14px;font-weight:500;">(cancelado)</span>
          </h3>

          <!-- CANCELED -->
          <h3 *ngIf="suscripcion.status === 'CANCELED'"
              style="margin:4px 0;font-size:clamp(18px, 3vw, 22px);color:#dc2626;">
            Cancelado
          </h3>

          <!-- PAST_DUE -->
          <h3 *ngIf="suscripcion.status === 'PAST_DUE'"
              style="margin:4px 0;font-size:clamp(18px, 3vw, 22px);color:#dc2626;">
            ⚠️ Pago pendiente
          </h3>

          <!-- FREE / otros -->
          <h3 *ngIf="suscripcion.status !== 'PREMIUM' && suscripcion.status !== 'CANCELANDO' && suscripcion.status !== 'CANCELED' && suscripcion.status !== 'PAST_DUE'"
              style="margin:4px 0;font-size:clamp(18px, 3vw, 22px);color:#64748b;">
            Free
          </h3>

          <span style="font-size:13px;color:#9ca3af;display:block;" *ngIf="suscripcion.activado">
            Activado: {{ suscripcion.activado | appDate:'mediumDate' }}
          </span>
          <span style="font-size:13px;display:block;margin-top:2px;"
                *ngIf="suscripcion.vence"
                [style.color]="suscripcion.status === 'CANCELANDO' ? '#d97706' : '#9ca3af'">
            Vence: {{ suscripcion.vence | appDate:'mediumDate' }}
          </span>

          <!-- Mensaje CANCELANDO -->
          <div *ngIf="suscripcion.status === 'CANCELANDO'"
               style="background:#fffbeb;border:1px solid #fde68a;border-radius:8px;padding:10px 14px;margin-top:12px;font-size:13px;color:#92400e;">
            Tu suscripción fue cancelada pero mantienes acceso Premium hasta el final del período. No se harán más cobros.
          </div>

          <!-- Mensaje PAST_DUE -->
          <div *ngIf="suscripcion.status === 'PAST_DUE'"
               style="background:#fef2f2;border:1px solid #fecaca;border-radius:8px;padding:10px 14px;margin-top:12px;font-size:13px;color:#991b1b;">
            Tienes un pago pendiente. Actualiza tu método de pago para mantener Premium.
          </div>
        </div>

        <!-- Acciones -->
        <div style="flex-shrink:0;display:flex;flex-direction:column;gap:8px;">
          <button *ngIf="suscripcion.status === 'PREMIUM'"
                  (click)="cancelar()"
                  style="background:#fef2f2;color:#dc2626;border:1px solid #fecaca;border-radius:8px;padding:10px 18px;font-size:13px;font-weight:600;cursor:pointer;white-space:nowrap;">
            Cancelar suscripción
          </button>
          <a *ngIf="suscripcion.status === 'FREE' || suscripcion.status === 'CANCELED'"
             routerLink="/planes"
             style="background:#16a34a;color:#fff;border-radius:8px;padding:10px 18px;font-size:13px;font-weight:600;text-decoration:none;display:inline-block;text-align:center;white-space:nowrap;">
            Activar Premium
          </a>
          <a *ngIf="suscripcion.status === 'PAST_DUE'"
             routerLink="/planes"
             style="background:#0ea5e9;color:#fff;border-radius:8px;padding:10px 18px;font-size:13px;font-weight:600;text-decoration:none;display:inline-block;text-align:center;white-space:nowrap;">
            Reactivar Premium
          </a>
        </div>

      </div>
    </div>

    <!-- ── Payment History ───────────────────────────────────────────────── -->
    <h3 style="font-size:16px;font-weight:700;color:#111827;margin-bottom:14px;">Historial de pagos</h3>
    <div *ngIf="!suscripcion.pagos?.length"
         style="background:#fff;border:1px solid #e5e7eb;border-radius:12px;padding:32px;text-align:center;color:#9ca3af;font-size:13px;">
      No hay pagos registrados.
    </div>
    <div *ngFor="let p of suscripcion.pagos"
         style="background:#fff;border:1px solid #e5e7eb;border-radius:10px;padding:16px 20px;margin-bottom:8px;display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:8px;">
      <div>
        <strong style="color:#111827;">${{ p.monto }} {{ p.moneda || 'MXN' }}</strong>
        <span style="color:#6b7280;font-size:13px;margin-left:10px;">{{ p.fecha | appDate:'mediumDate' }}</span>
      </div>
      <span [style.color]="p.status === 'PAGADO' ? '#059669' : '#dc2626'"
            style="font-size:12px;font-weight:600;padding:3px 10px;border-radius:100px;"
            [style.background]="p.status === 'PAGADO' ? '#f0fdf4' : '#fef2f2'">
        {{ p.status === 'PAGADO' ? '✓ Pagado' : p.status }}
      </span>
    </div>

  </div>
</div>
